export default "__VITE_ASSET__BfQ06yGL__"